import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { useFormik } from 'formik'
import style from './reporting.module.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import { components } from "react-select";
import { default as ReactSelect } from "react-select";
import { GetCsvReportAction } from '../../Redux/Actions/OPReportingAction';
import { GetReportingCradicialsAction } from '../../Redux/Actions/AdminActions';

const Option = (props: any) => {
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{" "}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const SourceOptions = [
    { value: "ALL", label: "ALL" },
    { value: "Google", label: "Google" },
    { value: "Facebook", label: "Facebook" },
    { value: "Beeswax", label: "Beeswax" },
    { value: "MyDSP", label: "MyDSP" },
];

const OPReportingView = () => {
    const [state, setState] = useState({
        start: moment().subtract(1, 'days'),
        end: moment().subtract(1, 'days')
    });
    const [optionSelected, setOptionSelected] = useState<any>([{ value: 'ALL', label: 'ALL' }])
    const { start, end } = state;
    const dispatch = useDispatch()
    const opreportingState = useSelector((state: any) => state.OPReporting)
    const { craditials = {} } = useSelector((state: any) => state.Admin)
    const label = start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY');
    const DatePickerCustomRange = {
        // Today: [moment().toDate(), moment().toDate()],
        Yesterday: [
            moment().subtract(1, 'days').toDate(),
            moment().subtract(1, 'days').toDate(),
        ],
        'Last 7 Days': [
            moment().subtract(6, 'days').toDate(),
            moment().toDate(),
        ],
        'Last 30 Days': [
            moment().subtract(29, 'days').toDate(),
            moment().toDate(),
        ],
        'This Month': [
            moment().startOf('month').toDate(),
            moment().endOf('month').toDate(),
        ],
        'Last Month': [
            moment().subtract(1, 'month').startOf('month').toDate(),
            moment().subtract(1, 'month').endOf('month').toDate(),
        ],
    };

    useEffect(() => {
        dispatch(GetReportingCradicialsAction())
    }, [dispatch])

    const handleCallback = (start: any, end: any) => {
        setState({ start, end });
    };

    const formikGetForm = useFormik({
        initialValues: {
            byDay: false,
            byCampaign: false
        },
        onSubmit: (value) => {
            const start1 = start.format('YYYY-MM-DD')
            const end1 = end.format('YYYY-MM-DD')
            // const formData = new FormData()
            // formData.append('start', start1)
            // formData.append('end', end1)
            // formData.append('source', JSON.stringify(optionSelected))
            // value.day && formData.append('day', 'on')
            // value.campaign && formData.append('campaign', 'on')
            let tempsource: any = ''
            optionSelected.map((item: any) => {
                tempsource = tempsource === '' ? item.label : tempsource + ',' + item.label;
                return tempsource;
            })
            // console.log({
            //     ...value,
            //     start: start1,
            //     end: end1,
            //     source: tempsource,
            //     fb_token: craditials.facebook_tokens,
            //     fb_accounts: craditials.facebook_account_ids,
            //     google_accounts: craditials.Google_account_ids
            // });
            dispatch(GetCsvReportAction({
                ...value,
                start: start1,
                end: end1,
                source: tempsource,
                fb_token: craditials.facebook_tokens,
                fb_accounts: craditials.facebook_account_ids,
                google_accounts: craditials.Google_account_ids
            }))
        }
    })

    const handleChange = (selected: any) => {
        setOptionSelected(selected)
    }

    return (
        <div>
            <Row className='d-flex justify-content-center mt-3'>
                <Col lg={10} md={6}>
                    <div>
                        <Form>
                            <Row>
                                <h3 style={{ color: "#000", textAlign: 'center' }}>
                                    OP Reporting
                                </h3>
                            </Row>
                            <Row style={{ marginTop: '40px', marginBottom: '20px', alignItems: 'center' }}>
                                <Col lg={4} className="mb-3">
                                    <Form.Group className="mb-3" >
                                        <Form.Label className={style.input_label}>Pick a Date</Form.Label>
                                        <DateRangePicker
                                            initialSettings={{
                                                startDate: start.toDate(),
                                                endDate: end.toDate(),
                                                ranges: DatePickerCustomRange,
                                                maxDate: moment().subtract(1, 'days').toDate(),
                                            }}
                                            onCallback={handleCallback}
                                        >
                                            <div className={style.date_range_input}>
                                                <i className="fa fa-calendar"></i>&nbsp;
                                                <span>{label}</span> <i className="fa fa-caret-down"></i>
                                            </div>
                                        </DateRangePicker>
                                    </Form.Group>
                                </Col>
                                <Col lg={3} className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className={style.input_label}>Source</Form.Label>
                                        <ReactSelect
                                            name='source'
                                            options={SourceOptions}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{ Option }}
                                            onChange={handleChange}
                                            value={optionSelected}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={1} className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className={style.input_label}>By Day</Form.Label>
                                        <Form.Check
                                            name='byDay'
                                            onChange={formikGetForm.handleChange}
                                            onBlur={formikGetForm.handleBlur}
                                            type="checkbox"
                                        // label="By Day"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={2} className="mb-3">
                                    <Form.Group className="mb-3">
                                        <Form.Label className={style.input_label}>By Campaign</Form.Label>
                                        <Form.Check
                                            name='byCampaign'
                                            onChange={formikGetForm.handleChange}
                                            onBlur={formikGetForm.handleBlur}
                                            type="checkbox"
                                        // label="By Campaign"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col lg={2} className="mb-3">
                                    <div className={style.campaignnew}>
                                        <Button
                                            onClick={() => formikGetForm.handleSubmit()}
                                            variant="dark" className="w-100"
                                        >
                                            {opreportingState?.loading && <Spinner
                                                as="span"
                                                animation="border"
                                                size="sm"
                                                role="status"
                                                aria-hidden="true"
                                            />}
                                            Get CSV
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>

                    </div>
                </Col>
            </Row>





            {/* <h3 style={{ color: "#fff", textAlign: 'center' }}>
                Reporting
            </h3>
            <Row className='d-flex justify-content-center mt-3'>
                <Col lg={7} md={7}>
                    <Card className='p-3'>
                        <Card.Body>
                            <div className={style.main_form}>
                                <Form>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Pick a Date</Form.Label>
                                        <DateRangePicker
                                            initialSettings={{
                                                startDate: start.toDate(),
                                                endDate: end.toDate(),
                                                ranges: DatePickerCustomRange,
                                                maxDate: moment().subtract(1, 'days').toDate(),
                                            }}
                                            onCallback={handleCallback}
                                        >
                                            <div className={style.date_range_input}>
                                                <i className="fa fa-calendar"></i>&nbsp;
                                                <span>{label}</span> <i className="fa fa-caret-down"></i>
                                            </div>
                                        </DateRangePicker>
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Source</Form.Label>
                                        <ReactSelect
                                            name='source'
                                            options={SourceOptions}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{ Option }}
                                            onChange={handleChange}
                                            value={optionSelected}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            name='day'
                                            onChange={formikGetForm.handleChange}
                                            onBlur={formikGetForm.handleBlur}
                                            type="checkbox"
                                            label="By Day"
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            name='campaign'
                                            onChange={formikGetForm.handleChange}
                                            onBlur={formikGetForm.handleBlur}
                                            type="checkbox"
                                            label="By Campaign"
                                        />
                                    </Form.Group>
                                    <div className={style.submit_btn}>
                                        <Button
                                            onClick={() => formikGetForm.handleSubmit()}
                                            variant="outline-dark"
                                        >
                                            Get CSV
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Card.Body>
                    </Card>
                </Col>
            </Row> */}
        </div>
    )
};

export default OPReportingView;  
